/**
 * Japanese (ja) — 日本語翻訳ファイル
 * All keys use flat namespace.key format
 */
export const ja: Record<string, string> = {
  // ── Menu Scenes ──────────────────────────────────────────
  'menu.play_game': 'ゲーム開始',
  'menu.version': 'v0.1.0 - PHASER移行版',
  'menu.back_to_menu': 'メニューに戻る',

  // ── Options ──────────────────────────────────────────────
  'options.title': 'オプション',
  'options.graphics': 'グラフィック',
  'options.audio': 'オーディオ',
  'options.gameplay': 'ゲームプレイ',
  'options.language': '言語',
  'options.resolution': '解像度:',
  'options.quality': '画質:',
  'options.fullscreen': 'フルスクリーン',
  'options.autosave': 'オートセーブ',
  'options.show_tooltips': 'ツールチップ表示',
  'options.master_volume': 'マスター音量',
  'options.music_volume': 'BGM音量',
  'options.sfx_volume': '効果音音量',
  'options.difficulty': '難易度:',
  'options.select_language': '言語を選択',

  // ── Login ────────────────────────────────────────────────
  'login.brand_crimson': 'CRIMSON',
  'login.brand_mandate': 'MANDATE',
  'login.tagline': '採掘\u2022交易\u2022征服\u2022USDCを稼ぐ',
  'login.version': 'CRIMSON MANDATE v0.1.0',
  'login.enter_email': 'メールアドレス入力',
  'login.email_placeholder': 'commander@fleet.com',
  'login.enter_password': 'パスワード入力',
  'login.password_placeholder': '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022',
  'login.remember_me': 'ログイン情報を記憶',
  'login.conquer_galaxy': '銀河を征服せよ',
  'login.connecting': '接続中...',
  'login.forgot_password': 'パスワードを忘れた方',
  'login.create_account': 'アカウント作成 >',
  'login.password_reset_soon': 'パスワードリセット機能は近日公開',
  'login.shop_banner': '艦船を購入するにはアカウントが必要です。下記からログインまたはアカウントを作成してください。',
  'login.enter_email_password': 'メールアドレスとパスワードを入力してください',
  'login.server_unavailable': 'サーバーに接続できません。しばらくしてから再度お試しください。',
  'login.login_failed': 'ログインに失敗しました',
  'login.connection_failed': '接続に失敗しました',
  'login.unknown_error': '不明なエラー',

  // ── Register ─────────────────────────────────────────────
  'register.commander_name': '司令官名',
  'register.username_placeholder': 'キャプテンノヴァ',
  'register.email_address': 'メールアドレス',
  'register.password': 'パスワード',
  'register.confirm_password': 'パスワード確認',
  'register.create_commander': '司令官を作成',
  'register.creating': '作成中...',
  'register.back_to_login': '< ログインに戻る',
  'register.strength_length': '\u2298 8文字以上',
  'register.strength_number': '\u2298 数字を含む',
  'register.strength_symbol': '\u2298 記号を含む',
  'register.passwords_match': '\u2713 パスワードが一致',
  'register.passwords_no_match': '\u2717 パスワードが一致しません',
  'register.fill_all_fields': 'すべての項目を入力してください',
  'register.name_too_short': '司令官名は3文字以上で入力してください',
  'register.password_too_short': 'パスワードは8文字以上で入力してください',
  'register.passwords_mismatch': 'パスワードが一致しません',
  'register.account_created_login': 'アカウント作成完了！ログイン中...',
  'register.account_created_connect': 'アカウント作成完了！接続中...',
  'register.connection_failed': 'アカウントは作成されましたが、ゲームへの接続がタイムアウトしました。ページを更新するかログインしてください。',
  'register.registration_failed': 'アカウント作成に失敗しました',

  // ── HUD Top Bar ──────────────────────────────────────────
  'hud.logo': 'CRIMSON\nMANDATE',
  'hud.menu': '\u2630 メニュー',

  // ── Nav Buttons ──────────────────────────────────────────
  'nav.wreck': '残骸',
  'nav.insure': '保険',
  'nav.trade': '交易',
  'nav.ore': '鉱石',
  'nav.crew': 'クルー',
  'nav.parts': 'パーツ',
  'nav.shop': 'ショップ',
  'nav.buy_isd': 'ISD購入',
  'nav.station': 'ステーション',
  'nav.center': '中央',
  'nav.follow': '追跡',
  'nav.research': '研究',
  'nav.tech': 'テック',
  'nav.alliance_hq': '同盟本部',
  'nav.refund': '買い戻し',
  'nav.withdraw': '出金',
  'nav.how_to': '遊び方',

  // ── Disconnect Overlay ───────────────────────────────────
  'disconnect.title': '接続が切断されました',
  'disconnect.idle': '無操作のため切断されました。',
  'disconnect.reconnecting': '再接続中... ({attempt}/{max})',
  'disconnect.failed': '再接続に失敗しました。',
  'disconnect.reconnect': '再接続',

  // ── Dialog Titles ────────────────────────────────────────
  'dialog.menu': 'メニュー',
  'dialog.ship_store': '艦船ストア',
  'dialog.components': 'コンポーネント',
  'dialog.ore_inventory': '鉱石インベントリ',
  'dialog.wreckage': '残骸回収',
  'dialog.insurance': '保険',
  'dialog.stations': 'ステーション',
  'dialog.crew_quarters': 'クルー居住区',
  'dialog.trade_hub': '交易ハブ',
  'dialog.browse_alliances': '同盟一覧',
  'dialog.alliance_hq': '同盟本部',
  'dialog.commander_profile': '司令官プロフィール',
  'dialog.refund': '買い戻し',
  'dialog.relic_inventory': 'レリックインベントリ',
  'dialog.tech_database': '技術データベース',
  'dialog.buy_isd': '$ISD購入',
  'dialog.ship_modification': '艦船改造',
  'dialog.while_away': '離席中のできごと',
  'dialog.research_board': '公開研究ボード',
  'dialog.component_enhancement': 'コンポーネント強化',
  'dialog.alliance': '同盟',
  'dialog.create_alliance': '同盟を設立',
  'dialog.alliance_management': '同盟管理',
  'dialog.direct_messages': 'ダイレクトメッセージ',
  'dialog.battle_report': '戦闘報告',
  'dialog.build_ship': '艦船建造 \u2014 {planetName}',
  'dialog.pirate_faction': '海賊勢力',
  'dialog.player_profile': 'プレイヤープロフィール',
  'dialog.ship_details': '艦船詳細',
  'dialog.component_loadout': 'コンポーネント装備',
  'dialog.repair_component': 'コンポーネント修理',
  'dialog.how_to': '遊び方',

  // ── Resource Display ─────────────────────────────────────
  'resource.title': 'リソース',
  'resource.credits': 'ISD',
  'resource.minerals': 'ミネラル',
  'resource.rare_metals': 'レアメタル',
  'resource.tech_data': '技術データ',
  'resource.salvage': 'サルベージ',
  'resource.exotic_matter': 'エキゾチック物質',

  // ── Left Sidebar ─────────────────────────────────────────
  'sidebar.empire_status': '帝国ステータス',
  'sidebar.stations': 'ステーション',
  'sidebar.ships': '艦船',
  'sidebar.explored': '探索済み',
  'sidebar.explored_hexes': '{count} ヘックス',
  'sidebar.credit': 'クレジット',
  'sidebar.fleet': '艦隊',
  'sidebar.missions': 'ミッション',
  'sidebar.no_ships': '配備中の艦船なし',
  'sidebar.no_stations': '配備中のステーションなし',
  'sidebar.planet': '惑星',
  'sidebar.station_label': 'ステーション',
  'sidebar.docked': 'ドッキング中',
  'sidebar.docked_at': '\u2693 {location}',
  'sidebar.moving': '移動中 ({turns}t)',
  'sidebar.hp_percent': 'HP {pct}%',
  'sidebar.cargo': '貨物 {used}/{cap}',
  'sidebar.no_missions': 'ミッションは\nありません',
  'sidebar.coming_soon': '近日公開',

  // ── Right Panel (Alliance) ───────────────────────────────
  'alliance.title': '同盟',
  'alliance.members': '{count} メンバー',
  'alliance.online': '{count} オンライン',
  'alliance.view': '表示',
  'alliance.message': 'メッセージ',
  'alliance.create': '設立',
  'alliance.browse': '一覧',

  // ── Chat Panel ───────────────────────────────────────────
  'chat.tab_chat': 'チャット',
  'chat.tab_log': 'ログ',
  'chat.channel_alliance': '同盟',
  'chat.channel_global': '全体',
  'chat.placeholder': 'メッセージを入力...',
  'chat.me': '自分',
  'chat.title': '通信',
  'chat.no_messages': 'メッセージはまだありません。\n下に入力して会話を始めましょう。',
  'chat.log_initialized': 'アクティビティログを初期化しました',

  // ── Command Dock ─────────────────────────────────────────
  // Action buttons
  'action.move': '移動',
  'action.attack': 'ENGAGE',
  'action.dock': 'ドッキング',
  'action.undock': '出港',
  'action.mine': '採掘',
  'action.stop': '停止',
  'action.repair': '修理',
  'action.modify': '改造',
  'action.goto': '座標移動',
  'action.return': '帰還',
  'action.cancel': 'キャンセル',
  'action.rename': '名前変更',
  'action.paint': '塗装',
  'action.sensor_boost': 'センサー強化',
  'action.warp': 'ワープ',
  'action.beacon': 'ビーコン',
  'action.deliver': '優先配送',
  'action.pick_color': '色を選択',
  'action.select_ship_attack': '攻撃する船を選択',
  'action.select_ship_move': '移動する船を選択',

  // Action tooltips
  'tooltip.move': '艦船をヘックスに移動する',
  'tooltip.attack': '敵艦を攻撃する',
  'tooltip.dock': '惑星またはステーションにドッキングする',
  'tooltip.undock': '現在の場所から出港する',
  'tooltip.mine': '小惑星からミネラルを採掘する',
  'tooltip.stop_mine': '採掘を中止する',
  'tooltip.repair': '貨物のミネラルで船体を修理する',
  'tooltip.repair_full': 'ユニットは最大HPです',
  'tooltip.modify': '造船所で艦船コンポーネントを改造する',
  'tooltip.modify_dock': 'ステーションにドッキングして改造する',
  'tooltip.goto': '指定座標へナビゲートする',
  'tooltip.return_to_base': '最寄りの友軍ステーションへ帰還し自動ドッキング',
  'tooltip.mine_minerals': 'ミネラルを採掘...',
  'tooltip.mine_stellar': 'ゴールドを採掘...',
  'tooltip.mine_move_adjacent': '採掘するには小惑星に隣接してください',
  'tooltip.dock_no_target': 'ドッキングするには惑星またはステーションの1ヘックス以内に移動してください',
  'tooltip.dock_no_range': 'ドッキング範囲内に惑星またはステーションがありません',
  'tooltip.dock_disabled': 'ここにはドッキングできません',
  'tooltip.undock_move': 'ドッキング解除して移動',
  'tooltip.repair_hull': '船体を修復',
  'tooltip.full_health': '満タン',
  'tooltip.modify_components': 'コンポーネントを変更',
  'tooltip.dock_to_modify': 'ドッキング後に変更可能',
  'tooltip.speed': '速度',
  'tooltip.attack_stat': '攻撃力',
  'tooltip.defense': '防御力',
  'tooltip.range': '射程',
  'tooltip.hull_integrity': '船体完全性',
  'tooltip.shields_desc': 'シールド説明',
  'tooltip.sensor_sweep': 'センサースイープ',
  'tooltip.evasive_maneuvers': '回避機動',
  'tooltip.afterburner': 'アフターバーナー',
  'tooltip.missile_barrage': 'ミサイル一斉射撃',
  'tooltip.broadside': '舷側一斉射撃',
  'tooltip.shield_overcharge': 'シールドオーバーチャージ',
  'tooltip.emergency_jump': '緊急ジャンプ',
  'tooltip.richness': '豊かさ',
  'tooltip.remaining_ore': '残り鉱石',
  'tooltip.rarity': 'レア度',
  'tooltip.asteroid_stellar': '暗号通貨を含む',
  'tooltip.asteroid_no_stellar': '暗号通貨なし',
  'tooltip.planet_structural': '惑星構造完全性',
  'tooltip.station_structural': 'ステーション構造完全性',
  'tooltip.mineral_storage': '鉱物貯蔵',
  'tooltip.docked_planet': '惑星にドッキング中',
  'tooltip.docked_station': 'ステーションにドッキング中',
  'tooltip.fee_earth': '地球手数料',
  'tooltip.fee_station': 'ステーション手数料',
  'tooltip.planet_status': '惑星ステータス',
  'tooltip.station_status': 'ステーションステータス',

  // Stat labels
  'stat.health': '船体',
  'stat.shields': 'シールド',
  'stat.speed': '速度',
  'stat.attack': '攻撃力',
  'stat.defense': '防御力',
  'stat.range': '射程',
  'stat.storage': '格納庫',
  'stat.docked': 'ドッキング中',
  'stat.fee': '手数料',
  'stat.status': 'ステータス',
  'stat.active': 'アクティブ',

  // Stat tooltips
  'stat_tip.health': '現在の船体耐久値',
  'stat_tip.shields': 'エネルギーシールド強度',
  'stat_tip.movement': 'ターンあたりの移動ヘックス数',
  'stat_tip.attack': '武器のダメージ出力',
  'stat_tip.defense': 'ダメージ軽減値',
  'stat_tip.range': '武器の最大射程',

  // Abilities
  'ability.scan': 'スキャン',
  'ability.evade': '回避',
  'ability.boost': 'ブースト',
  'ability.volley': '一斉射撃',
  'ability.broad': '舷側砲',
  'ability.shield': 'シールド',
  'ability.jump': 'ジャンプ',
  'ability.none': 'アビリティなし',

  'ability_tip.scan': '周辺エリアをスキャンする',
  'ability_tip.evade': '回避飛行モードに入る',
  'ability_tip.boost': 'エンジン速度をブーストする',
  'ability_tip.volley': '全武器を同時発射する',
  'ability_tip.broad': '舷側砲を発射する',
  'ability_tip.shield': 'シールドジェネレーターをオーバーチャージする',
  'ability_tip.jump': 'ワープジャンプを開始する',

  // Tabs (ship)
  'tab.actions': 'アクション',
  'tab.abilities': 'アビリティ',
  'tab.cargo': '貨物 {used}/{cap}',
  'tab.crew': 'クルー',
  'tab.upgrades': 'アップグレード',

  // Tabs (planet)
  'tab.storage': '倉庫',
  'tab.stellar': 'ゴールド',
  'tab.build': '建造',

  // Tabs (station)
  'tab.manage': '管理',

  // Cargo
  'cargo.full_tooltip': '貨物が満杯です！惑星またはステーションにドッキングして降ろしてください。',
  'cargo.loading': '貨物を読み込み中...',
  'cargo.empty': '貨物倉は空です',

  // Storage
  'storage.loading': 'インベントリを読み込み中...',
  'storage.empty': 'ミネラルの保管なし',
  'storage.stellar_stored': 'ゴールド保管量',
  'storage.buy_ship': '艦船購入',
  'storage.buy_parts': 'パーツ購入',
  'storage.buy_crew': 'クルー雇用',
  'storage.label': 'ストレージ',

  // Asteroid
  'asteroid.richness': '含有量',
  'asteroid.rarity': 'レアリティ',
  'asteroid.stellar': 'ゴールド',
  'asteroid.composition': '組成',
  'asteroid.no_mineral_data': 'ミネラルデータなし',
  'asteroid.remaining_ore': '残り鉱石',
  'asteroid.stellar_label': '暗号通貨',
  'asteroid.legendary': 'レジェンダリー',
  'asteroid.very_rich': '非常に豊富',
  'asteroid.rich': '豊富',
  'asteroid.moderate': '普通',
  'asteroid.poor': '貧弱',
  'asteroid.suffix': ' アステロイド',

  // Richness tiers
  'richness.legendary': 'レジェンダリー',
  'richness.very_rich': '非常に豊富',
  'richness.rich': '豊富',
  'richness.moderate': '普通',
  'richness.poor': '乏しい',

  // Rarity tiers
  'rarity.legendary': 'レジェンダリー',
  'rarity.epic': 'エピック',
  'rarity.rare': 'レア',
  'rarity.uncommon': 'アンコモン',
  'rarity.common': 'コモン',

  // Asteroid richness tooltips
  'asteroid_tip.richness': 'ミネラル含有量の品質',
  'asteroid_tip.rarity': 'このアステロイドの希少度',
  'asteroid_tip.stellar': '地球に牽引した時のゴールド報酬',

  // Asteroid variant names
  'asteroid_variant.gold': 'ゴールド',
  'asteroid_variant.platinum': 'プラチナ',
  'asteroid_variant.dark_matter': 'ダークマター',

  // Minerals
  'mineral.iron': '鉄',
  'mineral.copper': '銅',
  'mineral.titanium': 'チタン',
  'mineral.platinum': 'プラチナ',
  'mineral.rhodium': 'ロジウム',
  'mineral.palladium': 'パラジウム',
  'mineral.iridium': 'イリジウム',
  'mineral.dark_matter': 'ダークマター',
  'mineral.rare': 'レア',
  'mineral.common': 'コモン',
  'mineral.epic': 'エピック',
  'mineral.uncommon': 'アンコモン',

  // Wreck
  'wreck.suffix': ' 残骸',
  'wreck.time_left': '残り時間（時間）',
  'wreck.type': 'タイプ',
  'wreck.tow': '牽引',
  'wreck.repair_label': '修理',
  'wreck.your_wreck': 'あなたの残骸',
  'wreck.manage': '管理',
  'wreck.being_towed': '牽引中',
  'wreck.being_repaired': '修理中',
  'wreck.claimed': '回収済み',
  'wreck.claim': '回収',
  'wreck.repair': '修復',

  // Enemy / Unit
  'unit.you': '(自分)',
  'unit.enemy': '敵',
  'unit.loading': '読み込み中...',
  'unit.no_ships': '艦船がありません',
  'unit.select_attack': '攻撃する艦船を選択',
  'unit.select_move': '移動する艦船を選択',

  // Enemy actions
  'enemy.player': 'プレイヤー',
  'enemy.ship': '艦船',
  'enemy.message': 'メッセージ',
  'enemy.move_to': '移動先',
  'enemy.badge': '敵',

  // Planet
  'planet.home': '\u2605 母星',
  'planet.neutral': '中立',
  'planet.your_planet': 'あなたの惑星',
  'planet.docked': 'ドッキング中',
  'planet.fee': '手数料',
  'planet.status': 'ステータス',
  'planet.active': '稼働中',
  'planet.nothing_producing': '生産中のものはありません',
  'planet.no_production': '生産なし',
  'planet.done': '完了',
  'planet.in_progress': '進行中',
  'planet.more_queued': '+{n} 件がキュー待ち',
  'planet.produce_ship': '艦船を生産',
  'planet.produce_ship_tooltip': 'この惑星で新しい艦船を建造する',

  // Station
  'station.waypoint': 'ウェイポイント',
  'station.depot': 'デポ',
  'station.fortress': '要塞',
  'station.capital': 'キャピタル',
  'station.your_station': 'あなたのステーション',
  'station.stored_asteroids': '保管アステロイド',
  'station.docking_fee': 'ドッキング手数料',
  'station.manage_station': 'ステーション管理',
  'station.manage_tooltip': 'ステーション管理パネルを開く',
  'station.produce_tooltip': 'このステーションで新しい艦船を建造する',
  'station.enemy': '敵',
  'station.nothing_producing': '生産中のものなし',
  'station.no_production': '生産なし',
  'station.done': '完了',
  'station.in_progress': '進行中',
  'station.produce_ship': '艦船を生産',

  // Upgrades / Burn sinks
  'upgrade.rename': '改名',
  'upgrade.rename_prompt': '新しい艦名を入力してください（最大20文字）:',
  'upgrade.rename_tooltip': '艦船に固有の名前を付ける（100 ISD）',
  'upgrade.paint': '塗装',
  'upgrade.paint_tooltip': '艦船の色を変更する（100 ISD）',
  'upgrade.sensor': 'センサー+',
  'upgrade.sensor_tooltip': 'センサー範囲を1ヘックス拡張する（500 ISD）',
  'upgrade.warp': 'ワープ',
  'upgrade.warp_soon': 'ワープジャンプ：ヘックス選択は近日公開',
  'upgrade.warp_tooltip': 'ワープジャンプ能力を解放する（2000 ISD）',
  'upgrade.beacon': 'ビーコン',
  'upgrade.beacon_no_alliance': 'ビーコンを設置するには同盟に所属する必要があります',
  'upgrade.beacon_tooltip': '現在位置に艦隊ビーコンを設置する（200 ISD）',
  'upgrade.deliver': '優先',
  'upgrade.deliver_tooltip': '牽引の配送優先度を設定する（300 ISD）',
  'upgrade.pick_color': '色を選択',

  // Paint colors
  'color.red': 'レッド',
  'color.green': 'グリーン',
  'color.blue': 'ブルー',
  'color.yellow': 'イエロー',
  'color.pink': 'ピンク',
  'color.cyan': 'シアン',
  'color.orange': 'オレンジ',
  'color.white': 'ホワイト',

  // GOTO popup
  'goto.q': 'Q',
  'goto.r': 'R',
  'goto.go': '移動',

  // Ship types
  'ship.scout': 'スカウト',
  'ship.fighter': 'ファイター',
  'ship.destroyer': 'デストロイヤー',
  'ship.bomber': 'ボマー',
  'ship.trade_ship': '輸送艦',
  'ship.cruiser': 'クルーザー',
  'ship.carrier': 'キャリアー',
  'ship.battleship': '戦艦',
  'ship.dreadnought': 'ドレッドノート',
  'ship.titan': 'タイタン',
  'ship.space_tug': 'スペースタグ',
  'ship.alien_leviathan': 'エイリアン・リヴァイアサン',

  // Ship roles
  'role.recon': '偵察',
  'role.light_combat': '軽戦闘',
  'role.strike': '強襲',
  'role.heavy_strike': '重強襲',
  'role.logistics': '兵站',
  'role.heavy_combat': '重戦闘',
  'role.fleet_support': '艦隊支援',
  'role.assault': '突撃',
  'role.capital': '旗艦級',
  'role.flagship': 'フラッグシップ',

  // Ship store
  'store.credits': 'ISD: {n}',
  'store.loading_prices': '艦船価格を読み込み中...',
  'store.load_failed': '価格の読み込みに失敗しました。後で再度お試しください。',
  'store.buy_ship': '艦船を購入',
  'store.buy_parts': 'パーツを購入',
  'store.buy_crew': 'クルーを雇用',

  // Component categories
  'comp.all': '全て',
  'comp.weap': '武装',
  'comp.eng': 'エンジン',
  'comp.shld': 'シールド',
  'comp.armr': '装甲',
  'comp.snsr': 'センサー',
  'comp.rctr': 'リアクター',
  'comp.spec': '特殊',

  // Component tiers
  'tier.mk1': 'Mk I',
  'tier.mk2': 'Mk II',
  'tier.mk3': 'Mk III',
  'tier.mk4': 'Mk IV',
  'tier.proto': 'プロト',
  'tier.basic': 'ベーシック',
  'tier.improved': 'インプルーブド',
  'tier.advanced': 'アドバンスド',
  'tier.elite': 'エリート',
  'tier.experimental': 'エクスペリメンタル',

  // Component stats
  'comp_stat.hull_hp': '船体HP',
  'comp_stat.shields': 'シールド',
  'comp_stat.armor': '装甲',
  'comp_stat.speed': '速度',
  'comp_stat.evasion': '回避率',
  'comp_stat.sensor_range': 'センサー範囲',
  'comp_stat.accuracy': '命中率',
  'comp_stat.attack': '攻撃力',
  'comp_stat.defense': '防御力',
  'comp_stat.power_output': '出力',
  'comp_stat.cooldown_reduc': 'クールダウン短縮',
  'comp_stat.shield_regen': 'シールド再生',
  'comp_stat.damage': 'ダメージ',
  'comp_stat.fire_rate': '発射速度',

  // Hamburger menu
  'hamburger.audio': 'オーディオ',
  'hamburger.master': 'マスター',
  'hamburger.music': 'BGM',

  // Tutorial hint panel
  'tutorial.dismiss': 'X',
  'tutorial.skip': 'スキップ',

  // How To Guide
  'howto.title': '遊び方',
  'howto.skip': 'スキップ',
  'howto.next': '次へ',
  'howto.back': '戻る',
  'howto.done': '完了',
  'howto.launch': '開始 ▶',
  'howto.page1_title': 'ようこそ、司令官',
  'howto.page1_bullet1': 'あなたの艦隊、あなたの領域。すべての行動が痕跡を残す永続的な銀河。',
  'howto.page1_bullet2': '戦艦、採掘船、偵察船を建造。星々の間で領土を主張せよ。',
  'howto.page2_title': '未知を探索',
  'howto.page2_bullet1': 'ヘックスに移動して探索。センサーは近くの宇宙を明らかにし、残りは闇。',
  'howto.page2_bullet2': '地球の近くは安全。遠くなるほど豊か（そして危険）。',
  'howto.page3_title': '帝国を築く',
  'howto.page3_bullet1': '小惑星を採掘して資源を得る——鉄、プラチナ、ダークマターまで。',
  'howto.page3_bullet2': 'ステーションにドッキングして荷降ろし、修理、艦隊のアップグレード。',
  'howto.page4_title': '奪い取れ',
  'howto.page4_bullet1': 'ライバルを攻撃し、残骸を回収し、戦利品を奪え。',
  'howto.page4_bullet2': '敵のステーションを襲撃し、交易路を支配せよ。',
  'howto.page5_title': '自由に遊ぶ',
  'howto.page5_bullet1': 'アライアンスに参加して研究、領域、力を共有——または誰にも従わない。',
  'howto.page5_bullet2': '採掘者、海賊、大物、艦隊司令官としてソロで。あなた次第。',
  'howto.page6_title': '未知が待つ',
  'howto.page6_bullet1': '深宇宙でエイリアンの遺物、クリプトイド、リヴァイアサンを発見。',
  'howto.page6_bullet2': '銀河は広大。どう征服するかはあなた次第。',

  // Number formatting
  'format.millions': 'M',
  'format.thousands': 'K',

  // FTUE hints (from server, but client can also use for display)
  'ftue.brand_new': 'ようこそ、司令官！スカウト艦をクリックして選択してください。',
  'ftue.first_select': 'よくできました！近くのヘックスを右クリックしてスカウトを移動させましょう。',
  'ftue.first_move': '移動中です！マップを探索しましょう \u2014 暗いヘックスは未発見の領域です。',
  'ftue.explore_vision': 'アステロイドを見つけて「採掘」をクリックしてミネラルを収集しましょう。',
  'ftue.first_mine': '素晴らしい採掘です！地球にドッキングして貨物を降ろしましょう。',
  'ftue.first_dock': '艦船ストアを開いて購入可能な艦船を確認しましょう。',
  'ftue.understand_hud': 'トップバーのボタンで艦船の購入、交易などが行えます！',
  'ftue.first_purchase': '星々を征服する準備ができました！チュートリアル完了。',

  // Welcome asteroid
  'ftue.welcome_asteroid': 'ウェルカムギフトのアステロイドが近くに出現しました！採掘して報酬を受け取りましょう。',
  'asteroid.welcome_gift': 'ウェルカムギフト',
  'notification.welcome_claimed': 'ウェルカム報酬を獲得しました！',

  // ── Mineral Inventory Dialog ──────────────────────────────
  'ore.browse_trade': '取引所を見る',
  'ore.total_mined': '総採掘量',
  'ore.base_value': '基本価値',
  'ore.market_data': 'マーケットデータ',
  'ore.lowest': '最安値',
  'ore.average': '平均',
  'ore.highest': '最高値',
  'ore.active_listings': '出品中',
  'ore.no_listings': '出品なし',
  'ore.sell': '売却',
  'ore.select_location': '場所を選択して鉱物を表示',
  'ore.total_minerals': '鉱物合計',
  'ore.mineral_types': '鉱物種類',
  'ore.stored_minerals': '保管鉱物',
  'ore.est_value': '推定価値（基本）',
  'ore.in_inventory': '所持中',
  'ore.tab_all': '全て',
  'ore.tab_by_location': '場所別',

  // ── Alliance HQ Dialog ────────────────────────────────────
  'alliance_hq.outpost': '前哨基地',
  'alliance_hq.station': 'ステーション',
  'alliance_hq.fortress': '要塞',
  'alliance_hq.citadel': '城塞',
  'alliance_hq.equal_split': '均等分配',
  'alliance_hq.rank_weighted': 'ランク加重',
  'alliance_hq.activity_weighted': '活動加重',
  'alliance_hq.custom': 'カスタム',

  // ── Station Management Dialog ─────────────────────────────
  'station_mgmt.basic_desc': '基本補給所。低容量・低コスト。',
  'station_mgmt.mid_desc': '中級物流拠点。拡張された保管容量。',
  'station_mgmt.fort_desc': '重防御の前哨基地。強力な防御力。',
  'station_mgmt.capital_desc': '大型司令部。最大の保管能力と存在感。',
  'station_mgmt.hp': 'HP',
  'station_mgmt.storage': '保管',
  'station_mgmt.owned_stations': '所有ステーション',
  'station_mgmt.no_stations': 'ステーション未所有',
  'station_mgmt.get_started': '上のステーションを購入して開始',

  // ── Wreckage Dialog — time formatting ────────────────────
  'time.days': '日',
  'time.hours': '時',
  'time.minutes': '分',
  'time.expired': '期限切れ',

  // Crew tab
  'crew.loading': 'クルー読み込み中...',
  'crew.none_assigned': 'クルー未配属',
  'crew.skill_combat': '戦闘',
  'crew.skill_piloting': '操縦',
  'crew.skill_navigation': '航法',
  'crew.skill_engineering': '工学',
  'crew.skill_science': '科学',

  // ── Leaderboard ────────────────────────────────────────────
  'nav.leaderboard': 'ランキング',
  'dialog.leaderboard': '同盟ランキング',
  'leaderboard.rank': '順位',
  'leaderboard.alliance': '同盟',
  'leaderboard.prestige': '名声',
  'leaderboard.territory': '領土',
  'leaderboard.members': 'メンバー',
  'leaderboard.hq_tier': '本部等級',
  'leaderboard.no_data': '同盟データがありません。',
  'leaderboard.refresh': '更新',

  // ── Platforms ─────────────────────────────────────────────
  'platform.basic': '基本プラットフォーム',
  'platform.advanced': '上級プラットフォーム',
  'platform.elite': 'エリートプラットフォーム',
  'platform.legendary': 'レジェンダリープラットフォーム',
  'platform.deploy': 'プラットフォーム配備',
  'platform.relocate': 'プラットフォーム再配置',
  'platform.manage': 'プラットフォーム管理',
  'platform.purchase': 'プラットフォーム購入',
  'platform.mining_yield': '軌道採掘産出量',
  'platform.storage': 'プラットフォームストレージ',
  'platform.capabilities': '機能',
  'platform.dock': 'ドッキングベイ',
  'platform.repair': '修理ベイ',
  'platform.shipyard': '造船所',
  'platform.build': 'ユニット建造',
  'platform.mining': '軌道採掘',
  'platform.earth_station': '地球軌道ステーション',
  'platform.public': '公共プラットフォーム',
  'planet.resources': '惑星資源',
  'planet.depleted': '枯渇',
  'planet.remaining': '残り',
  'commanddock.dock_platform': 'プラットフォームにドッキング',
};
